export const REDUCER_NAME = 'foil'



// WEBPACK FOOTER //
// ./src/modules/foil/state/const.js